<mat-accordion>
  @for (data of dataFAQ; track data) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ data.question | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p>{{ data.answer | translate }}</p>
    </mat-expansion-panel>
  }
</mat-accordion>
